<div class="item">
    <div *ngIf="company.logoPath" class="item_image"><img class="item_image-img" [src]="company.logoPath"></div>
    <div *ngIf="!company.logoPath" class="item_image" [ngStyle]="{'background-color': color}"><p>{{initials | titlecase}}</p></div>
    <div class="item_detail">
      <div class="item_detail-title">{{ company.companyName | titlecase }}</div>
        <span class="body" [ngClass]="!isFullWidth ? 'flex-wrap': 'w-100'">
            <span class="email set-length" [ngClass]="isFullWidth ? 'flex-50': 'w-100'"><i class="fas fa-envelope"></i> {{ company.email}}</span>
            <span class="phone" [ngClass]="isFullWidth ? 'flex-50': 'w-100'"><img width="11" src="../../../assets/images/phone-icon.svg">{{company.phone}}</span>
        </span>
    </div>
  </div>
